import L from 'leaflet'

// action types
export const UPDATE_LAST_CLICKED = 'updateLastClicked'
export const UPDATE_LEVEL = 'updateLevel'
export const UPDATE_ZOOM = 'updateZoom'
export const UPDATE_CENTER = 'updateCenter'
export const UPDATE_BOUNDS = 'updateBounds'
export const UPDATE_REGION_ID = 'updateRegionId'

// mutation types
export const SET_LAST_CLICKED = 'setLastClicked'
export const SET_LEVEL = 'setLevel'
export const SET_ZOOM = 'setZoom'
export const SET_CENTER = 'setCenter'
export const SET_BOUNDS = 'setBounds'
export const SET_REGION_ID = 'setRegionId'

const state = {
  map_activities: {
    last_clicked: 'IDN',
    level: 'national',
    zoom: 5,
    center: L.latLng(-2.1002097, 118.443984),
    bounds: '',
  },
  isDropdown: false,
  toggledIndicator: 'Readiness',
  region_id: '1',
}

const getters = {
  currentUserActivity(state) {
    return state.map_activities
  },
  getLevel(state) {
    return state.map_activities.level
  },
  getRegionId(state) {
    return state.region_id
  },
}

const actions = {
  [UPDATE_LAST_CLICKED](context, payload) {
    context.commit(SET_LAST_CLICKED, payload)
  },
  [UPDATE_LEVEL](context, payload) {
    context.commit(SET_LEVEL, payload)
  },
  [UPDATE_ZOOM](context, payload) {
    context.commit(SET_ZOOM, payload)
  },
  [UPDATE_CENTER](context, payload) {
    context.commit(SET_CENTER, payload)
  },
  [UPDATE_BOUNDS](context, payload) {
    context.commit(SET_BOUNDS, payload)
  },
  [UPDATE_REGION_ID](context, payload) {
    context.commit(SET_REGION_ID, payload)
  },
}

const mutations = {
  [SET_LAST_CLICKED](state, payload) {
    state.map_activities.last_clicked = payload
  },
  [SET_LEVEL](state, payload) {
    state.map_activities.level = payload
  },
  [SET_ZOOM](state, payload) {
    state.map_activities.zoom = payload
  },
  [SET_CENTER](state, payload) {
    state.map_activities.center = payload
  },
  [SET_BOUNDS](state, payload) {
    state.map_activities.bounds = payload
  },
  [SET_REGION_ID](state, payload) {
    state.region_id = payload
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
